import { ReactElement, useCallback } from 'react';
import {
  AuthenticationError,
  AxiosResult,
  AxiosResultDefaultError,
} from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import { CareersResponse } from '../../type';
import { PaginationQuery } from '../../../../../types/pagination';
import DisplayError from '../../../../../components/info/DisplayError';
import { getCareersList } from '../../api';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  PaginationQuery,
  CareersResponse,
  AuthenticationError | AxiosResultDefaultError
>();

export function useCareersLoader() {
  return useFetch();
}

export const CareersLoaderConsumer = FetchConsumer;

export default function CareersLoader({ children }: BaseLoaderProps) {
  const request = useCallback(
    async (
      query: PaginationQuery,
    ): Promise<AxiosResult<CareersResponse, AxiosResultDefaultError>> => {
      return getCareersList(query);
    },
    [],
  );

  return (
    <FetchProvider
      request={request}
      defaultQuery={{
        page: 1,
        itemsPerPage: 10,
      }}
      fetchImmediately
    >
      <CareersLoaderConsumer>
        {({ error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                typeError={(error as any)?.code}
                retryAction={refresh}
              />
            );
          }
          return children;
        }}
      </CareersLoaderConsumer>
    </FetchProvider>
  );
}
